import React, { useCallback, useEffect, useState } from 'react'
import "../../styles/manageAccount/manageAccount.css"
import { renderSvg } from '../manageAccount/renderSvg'
import HeaderNonSrp from '../header/headerNonSrp'
import SubHeader from '../header/subHeader'
import Footer from '../footer/footer'
import BusTicketBook from './busTicketBook'
import { BUS_TICKET_BOOKING, BUS_TRUCK_HIRE, CARGO_BOOKING, TOUR_PACKAGE_BOOKING, tCommon } from '../../translations/Common'
// import { useHistory } from 'react-router-dom';
import GoogleRecaptchaV3 from '../common/GoogleRecaptchaV3'

const BookingEnquiry = (props) => {
    const { search } = props

    const handleClick = () => {
        // Navigate to a different route upon button click
        setTabs(0)
        //   history.push("/manageAccount/busTcktBooking");
    };
    // const []
    const [tabs, setTabs] = useState(0)
    const [captchaToken, setCaptchaToken] = useState("");
    const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);

    const onCaptchaVerify = useCallback((token) => {
        setCaptchaToken(token);
    }, []);

    const refreshCaptchaToken = useCallback(() => {
        setRefreshReCaptcha((r) => !r);
    }, []);

    return (
        <div>
            <HeaderNonSrp />
            <SubHeader />
            <div className='manage-container'>
                <div className="manage-Tabs">
                    <div className={`tabs ${tabs == 0 && "active"}`} onClick={() => handleClick()}>
                        {renderSvg("mitra")}
                        <span className="header-right-item-text">{tCommon(BUS_TICKET_BOOKING)}</span>
                    </div>
                    {/* <div className={`tabs ${tabs == 1 && "active"}`} onClick={() => setTabs(1)}>
                        {renderSvg("TourPack")}
                        <span className="header-right-item-text">{tCommon(TOUR_PACKAGE_BOOKING)}</span>
                    </div> 
                    <div className={`tabs ${tabs == 2 && "active"}`} onClick={() => setTabs(2)}>
                        {renderSvg("BusTruck")}
                        <span className="header-right-item-text">{tCommon(BUS_TRUCK_HIRE)}</span>
                    </div>
                    <div className={`tabs ${tabs == 3 && "active"}`} onClick={() => setTabs(3)}>
                        {renderSvg("cargoBkg")}
                        <span className="header-right-item-text">{tCommon(CARGO_BOOKING)}</span>
                    </div>*/}
                </div>

                {
                    tabs == 0 && (
                        <BusTicketBook
                            captchaToken={captchaToken}
                            refreshCaptchaToken={refreshCaptchaToken}
                        />
                    )
                }

            </div>
            <Footer />
            <GoogleRecaptchaV3
                onVerify={onCaptchaVerify}
                refreshReCaptcha={refreshReCaptcha}
            />
        </div>
    )
}

export default BookingEnquiry;
